//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./activity.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// struct ActivityItem
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ActivityItem.Mutable`. */
export class ActivityItem extends $._FrozenBase {}

function initActivityItem(target, initializer) {
  target.id = initializer.id ?? "";
  target.kind = initializer.kind ?? "";
  target.category = initializer.category ?? "";
  target.actorKind = initializer.actorKind ?? "";
  target.actorUserId = initializer.actorUserId ?? "";
  target.actorName = initializer.actorName ?? "";
  target.subjectKind = initializer.subjectKind ?? "";
  target.subjectId = initializer.subjectId ?? "";
  target.title = initializer.title ?? "";
  target.body = initializer.body ?? "";
  target.occurredAt = initializer.occurredAt ?? $.Timestamp.UNIX_EPOCH;
  target.isNotification = initializer.isNotification ?? false;
  target.read = initializer.read ?? false;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "activity.skir",
  [
    {
      kind: "struct",
      ctor: ActivityItem,
      initFn: initActivityItem,
      name: "ActivityItem",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "kind",
          property: "kind",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "category",
          property: "category",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "actor_kind",
          property: "actorKind",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "actor_user_id",
          property: "actorUserId",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "actor_name",
          property: "actorName",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "subject_kind",
          property: "subjectKind",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "subject_id",
          property: "subjectId",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "title",
          property: "title",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "body",
          property: "body",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "occurred_at",
          property: "occurredAt",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "is_notification",
          property: "isNotification",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "read",
          property: "read",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
  ]
);
